<template>
  <v-card>
    <v-tabs v-model="tab">
      <v-tab> All </v-tab>
      <v-tab> My Job </v-tab>
    </v-tabs>
    <div v-if="tab == 0">
      <div class="border-bottom pa-5 mb-5">
        <v-row class="align-end">
          <v-col md="6" cols="12">
            <v-text-field
              outlined
              solo
              flat
              dense
              hide-details
              clearable
              placeholder="Search Music"
              v-model="query"
            ></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <p class="ma-0">Search Date</p>
            <v-menu
              v-model="showPicker"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              full-width
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="deadline"
                  outlined
                  dense
                  hide-details=""
                  persistent-hint
                  readonly
                  v-on="on"
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="deadline"
                no-title
                :max="
                  new Date().getFullYear() + '-' + (new Date().getMonth() + 1)
                "
                @input="showPicker = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </div>
      <div
        v-if="musicRoomLoading"
        class="d-flex align-items-center justify-center py-5"
      >
        <v-progress-circular indeterminate />
      </div>
      <v-row v-else>
        <v-col
          v-for="(musicRoom, k) of lc_getMusicRooms()"
          :key="k"
          md="6"
          cols="12"
        >
          <MusicCard :music="musicRoom" v-bind:paid="false" />
        </v-col>
      </v-row>
    </div>
    <div v-if="tab == 1">
      <div class="border-bottom pa-5">
        <v-row class="align-end">
          <v-col md="6" cols="12">
            <v-text-field
              outlined
              solo
              flat
              dense
              hide-details
              placeholder="Search Jobs"
              v-model="query"
            ></v-text-field>
          </v-col>
          <v-col md="6" cols="12">
            <p class="ma-0">Search Date</p>
            <v-menu
              v-model="showPicker"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              full-width
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="deadline"
                  hide-details=""
                  outlined
                  dense
                  persistent-hint
                  readonly
                  v-on="on"
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="deadline"
                no-title
                :max="new Date().toISOString().slice(0, 10)"
                @input="showPicker = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </div>
      <div class="d-flex pa-4 mb-6 pb-0">
        <v-btn class="ml-auto" color="primary" @click="addDialog = true"
          >Add Job</v-btn
        >
      </div>
      <div
        v-if="musicRoomLoading"
        class="d-flex align-items-center justify-center py-5"
      >
        <v-progress-circular indeterminate />
      </div>
      <v-row v-else>
        <v-col v-for="(job, k) of lc_getMusicRooms()" :key="k" md="6" cols="12">
          <job-card :job="job" v-bind:paid="true" />
        </v-col>
      </v-row>
    </div>

    <v-dialog v-model="addDialog" width="500">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Add Job</v-toolbar-title>
        </v-toolbar>
        <v-form ref="ref_add_job" @submit="lc_add_job">
          <div class="pa-4">
            <v-text-field
              dense
              flat
              label="Title"
              outlined
              v-model="data.title"
              :rules="[myrules.required]"
            ></v-text-field>
            <v-text-field
              v-model="data.description"
              :rules="[myrules.required]"
              dense
              flat
              label="Description"
              outlined
            ></v-text-field>
            <v-autocomplete
              deletable-chips
              multiple
              small-chips
              solo
              flat
              dense
              outlined
              label="Genre"
              v-model="data.genre"
              :rules="[myrules.arrayRequired]"
              :items="getGenre"
            ></v-autocomplete>
            <v-checkbox
              dense
              color="primary"
              outlined
              label="Paid"
              v-model="data.paid"
            ></v-checkbox>
            <div v-if="data.paid">
              <v-text-field
                dense
                flat
                label="Amount"
                v-model="data.amount"
                :rules="data.paid ? [myrules.required] : []"
                outlined
              ></v-text-field>
            </div>
            <v-menu
              v-model="showPicker1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              full-width
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="data.deadline"
                  label="Deadline"
                  outlined
                  dense
                  persistent-hint
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="data.deadline"
                :min="new Date().toISOString().substr(0, 11)"
                no-title
                @input="showPicker1 = false"
              ></v-date-picker>
            </v-menu>
            <div class="d-flex mt-4">
              <v-btn
                class="mr-3"
                color="red white--text"
                @click="addDialog = false"
                >Cancel</v-btn
              >
              <v-btn color="primary" type="submit">Add</v-btn>
            </div>
          </div>
        </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import JobCard from "../components/music/JobCard.vue";
import MusicCard from "../components/music/MusicCard.vue";
import moment from "moment";
export default {
  name: "Music",
  components: { MusicCard, JobCard },
  data() {
    return {
      isPaid: false,
      showPicker: false,
      showPicker1: false,
      tab: null,
      addDialog: false,
      deadline: null,
      paid: false,
      query: null,
      data: {
        title: "",
        description: "",
        genre: [],
        paid: false,
        deadline: "",
      },
    };
  },
  mounted() {
    let id = this.authUser.id;
    this.getMusicRooms();
    this.getFeaturedMusicRooms(id);
  },
  methods: {
    getPaid() {
      this.isPaid = !this.isPaid;
      return this.isPaid;
    },
    async lc_add_job(e) {
      e.preventDefault();
      let validate = this.$refs.ref_add_job.validate();

      if (validate) {
        this.addMusicRoom({ ...this.data, added_by: this.authUser.id });
        this.$refs.ref_add_job.reset();
        this.addDialog = false;
      }
    },
    lc_getMusicRooms() {
      let rooms;
      
      if (this.tab == 0) {
        rooms = this.musicRooms;
      } else {
        rooms = this.featuredMusicRooms;
      }
      
      let filteredRooms = rooms;
      
      if (this.query != null) {
        filteredRooms = filteredRooms.filter((room) =>
          room.title.toLowerCase().includes(this.query.toLowerCase())
        );
      }
      if (this.deadline != null) {
        filteredRooms = filteredRooms.filter((room) => {
          
          
          var isafter =
            moment(new Date(this.deadline)) <= moment(new Date(room.deadline));
          
          return isafter;
        });
      }
      return filteredRooms;
    },
  },
  computed: {
    ...mapGetters(["getGenre"]),
  },
};
</script>

<style scoped>
</style>